/* Solgt-boksen (serie 22, retning A). Markup: snippets/solgt-boks.liquid. Landing: assets/solgt-besok.js (window.ggLanding, avklart
   når window.ggLandingAvklart er true og hendelsen gg:landing er sendt). Logikk: docs/varesystem/logikk/solgte-varer.md.
   - Bare for dem som landet på en solgt vare: tilbudskortet nederst, når samtykkebanneret er besvart eller ikke trengs, og når kortet
     ikke dekker tittel, bilde eller boksen. Ellers er boksen vanlige lenker og ingen rabatt nevnes.
   - Kurven leses én gang når siden er avklart som landing. Har den en annen kode, eller kan den ikke leses, vises ikke kortet og
     klikket legger ingenting på (update.js erstatter alle koder, så en annen kode skal stå). Har den GB10 fra før, vises kortet.
   - Klikk på en lenke i boksen eller kortet (landet): rabattkoden og handlekurvattributtet kilde: solgt-vare legges på med
     /cart/update.js (shopify.dev, Ajax Cart API, «Update discounts in the cart»), så går lenken videre. Ctrl-, Cmd-, Shift- og midtklikk
     (ny fane) legger dem på uten å stoppe lenken. Kurven leses på nytt rett før oppdateringen (best mulig: lesing og skriving er to
     kall, en kode lagt til i en annen fane i mellomtiden kan bli erstattet). Tar det over 2,5 s, går lenken videre uten å vente; en
     oppdatering som alt er sendt kan likevel fullføres. Rabattmeldingen (sections/rabatt-melding.liquid) ser attributtet på neste side
     og leser kurvens kode, så «Koden … er lagt til» vises etter klikket (ikke hvis siden lastes før oppdateringen er lagret).
   - Hendelsene gjenbruksgiganten:solgt_vist, solgt_klikket og solgt_lukket sendes med Shopify.analytics.publish (når web pixels).
   - Lukket kort huskes for besøket bare med uttrykkelig ja til preferanser (ekomloven § 3-15), ellers bare på denne siden. */
(function () {
  'use strict';
  const boks = document.querySelector('[data-gg-solgt-boks]');
  if (!boks || boks.dataset.klar) return;
  boks.dataset.klar = '1';

  const kode = (boks.dataset.kode || '').trim();
  const tilbud = document.querySelector('[data-gg-solgt-tilbud]');
  const LUKKET = 'gg_solgt_lukket';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let vistSendt = false;
  let lukket = false;
  let kurvKlar = null; // null: ikke lest ennå, true: ingen annen kode i kurven, false: annen kode eller kurven kunne ikke leses
  let kurvLest = false;

  function landet() {
    return window.ggLandingAvklart === true && window.ggLanding === true && kode !== '';
  }

  function cp() {
    const c = window.Shopify && window.Shopify.customerPrivacy;
    return c && typeof c.currentVisitorConsent === 'function' ? c : null;
  }
  function samtykke() {
    try { return (cp() && cp().currentVisitorConsent()) || {}; } catch (e) { return {}; }
  }
  function prefJa() {
    return samtykke().preferences === 'yes';
  }
  function lesLukket() {
    if (!prefJa()) return false;
    try { return sessionStorage.getItem(LUKKET) === '1'; } catch (e) { return false; }
  }
  function skrivLukket() {
    if (!prefJa()) return;
    try { sessionStorage.setItem(LUKKET, '1'); } catch (e) { /* sperret */ }
  }

  function send(navn, ekstra) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('gjenbruksgiganten:' + navn, Object.assign({
          modus: boks.dataset.modus,
          kategori: boks.dataset.kategori,
          produkt: boks.dataset.produkt
        }, ekstra || {}));
      }
    } catch (e) { /* måling skal aldri stoppe siden */ }
  }
  function vist(hva) {
    if (vistSendt) return;
    vistSendt = true;
    send('solgt_vist', { hva: hva });
  }

  /* Samtykkebanneret (sections/samtykkebanner.liquid, samme regel som skalVises i samtykkebanner.js): ferdig når kunden har svart på
     noe, eller når Shopify sier at banneret ikke trengs og alle formålene er tillatt. Åpent banner: body har klassen gg-sb-apen. */
  function bannerFerdig() {
    const c = cp();
    if (!c) return false;
    const s = samtykke();
    if (s.marketing || s.analytics || s.preferences) return true;
    try {
      if (typeof c.shouldShowBanner === 'function' && c.shouldShowBanner()) return false;
      return c.marketingAllowed() && c.analyticsProcessingAllowed() && c.preferencesProcessingAllowed();
    } catch (e) {
      return false;
    }
  }

  let kortFlate = null; // kortets plass i vinduet (fast posisjon), måles på nytt når kortet eller skriften endrer størrelse
  function maalKort() {
    const varSkjult = tilbud.hidden;
    if (varSkjult) { tilbud.style.visibility = 'hidden'; tilbud.hidden = false; }
    const r = tilbud.getBoundingClientRect();
    if (varSkjult) { tilbud.hidden = true; tilbud.style.visibility = ''; }
    kortFlate = { fraBunn: window.innerHeight - r.top, hoyde: r.height, left: r.left, right: r.right };
  }
  // Kortet dekker aldri tittelen, bildeområdet (hele galleriet, så det synlige bildet er med) eller solgt-boksen
  function dekker() {
    if (!kortFlate) maalKort();
    const top = window.innerHeight - kortFlate.fraBunn;
    const a = { top, bottom: top + kortFlate.hoyde, left: kortFlate.left, right: kortFlate.right };
    return ['.product-info h1', '#product-media', '[data-gg-solgt-boks]'].some((s) => {
      const e = document.querySelector(s);
      if (!e) return false;
      const r = e.getBoundingClientRect();
      return !(r.bottom <= a.top || r.top >= a.bottom || r.right <= a.left || r.left >= a.right);
    });
  }

  // Kurven leses én gang når landingen er avklart: kortet lover bare GB10 når koden faktisk kan legges på
  function lesKurv() {
    if (kurvLest || !landet()) return;
    kurvLest = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((svar) => (svar.ok ? svar.json() : null))
      .then((kurv) => {
        const koder = kurv && Array.isArray(kurv.discount_codes) ? kurv.discount_codes : null;
        kurvKlar = !!koder && koder.every((d) => d && typeof d.code === 'string' && d.code.toUpperCase() === kode.toUpperCase());
      })
      .catch(() => { kurvKlar = false; })
      .finally(oppdater);
  }

  function oppdater() {
    lesKurv();
    const vis = landet() && kurvKlar === true;
    if (tilbud) {
      let kortVis = vis && !lukket && !lesLukket() && bannerFerdig() && !document.body.classList.contains('gg-sb-apen');
      // Har kunden fokus i kortet, blir det stående selv om det nå ville dekket noe
      if (kortVis && !tilbud.contains(document.activeElement) && dekker()) kortVis = false;
      tilbud.hidden = !kortVis;
      document.body.classList.toggle('gg-solgt-tilbud-apen', kortVis);
      if (kortVis) vist('kort');
    }
  }

  if (tilbud) {
    new MutationObserver(oppdater).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if ('ResizeObserver' in window) new ResizeObserver(() => { kortFlate = null; if (!tilbud.hidden) oppdater(); }).observe(tilbud);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { kortFlate = null; oppdater(); });
    let rammeVenter = false;
    window.addEventListener('scroll', () => {
      if (rammeVenter) return;
      rammeVenter = true;
      requestAnimationFrame(() => { rammeVenter = false; oppdater(); });
    }, { passive: true });
    window.addEventListener('resize', () => { kortFlate = null; oppdater(); });
    document.addEventListener('visitorConsentCollected', () => setTimeout(oppdater, 0));
    // Banneret avgjøres når API-et er lastet; sjekk jevnlig de første 30 sekundene i tillegg til hendelsene over
    const start = Date.now();
    (function sjekk() {
      oppdater();
      if (Date.now() - start < 30000 && tilbud.hidden && !lukket) setTimeout(sjekk, 500);
    })();
    const lukk = tilbud.querySelector('[data-gg-solgt-lukk]');
    if (lukk) {
      lukk.addEventListener('click', () => {
        lukket = true;
        skrivLukket();
        send('solgt_lukket');
        oppdater();
        // Fokus til knappen i boksen, så tastaturbrukere ikke mister plassen
        const videre = boks.querySelector('.gg-solgt__knapp') || boks;
        if (videre === boks) boks.setAttribute('tabindex', '-1');
        videre.focus({ preventScroll: true });
      });
    }
  }
  document.addEventListener('gg:landing', oppdater);
  // Tilbake til fanen: kurven kan ha fått en annen kode i en annen fane, så den leses på nytt
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible' || !kurvLest) return;
    kurvLest = false;
    lesKurv();
  });
  oppdater();

  // Koden og handlekurvattributtet i ett kall. stopp() sier om lenken alt har gått videre, så kjeden avsluttes da.
  async function leggPaRabatt(stopp) {
    const svar = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!svar.ok) throw new Error('cart.js ' + svar.status);
    const kurv = await svar.json();
    if (!kurv || !Array.isArray(kurv.discount_codes)) throw new Error('cart.js uten discount_codes');
    if (stopp()) return;
    const andre = kurv.discount_codes.filter((d) => !d || String(d.code).toUpperCase() !== kode.toUpperCase());
    if (andre.length) { // en annen kode står, ingenting legges på (heller ikke attributtet), og kortet skjules
      kurvKlar = false;
      oppdater();
      return;
    }
    const kropp = { attributes: { kilde: 'solgt-vare' } };
    if (kurv.discount_codes.length === 0) kropp.discount = kode;
    const oppdatert = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(kropp),
      keepalive: true
    });
    if (!oppdatert.ok) throw new Error('update.js ' + oppdatert.status);
  }

  function lenkeFra(e) {
    const a = e.target.closest('[data-gg-solgt-lenke]');
    // Kortet krever avklart kurv; et klikk mens første lesing pågår gjør sin egen kontroll i leggPaRabatt
    return a && landet() && kurvKlar !== false ? a : null;
  }
  function klikk(e) {
    const a = lenkeFra(e);
    if (!a || e.defaultPrevented) return;
    const fra = tilbud && tilbud.contains(a) ? 'kort' : 'boks';
    // Ny fane (Ctrl, Cmd, Shift): lenken åpnes som vanlig, rabatten legges på kurven i bakgrunnen
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      send('solgt_klikket', { til: a.getAttribute('href'), fra, nyFane: true });
      leggPaRabatt(() => false).catch(() => {});
      return;
    }
    e.preventDefault();
    const til = a.href;
    send('solgt_klikket', { til: a.getAttribute('href'), fra });
    let ferdig = false;
    const ga = () => { if (!ferdig) { ferdig = true; location.href = til; } };
    setTimeout(ga, 2500);
    leggPaRabatt(() => ferdig).catch(() => {}).finally(ga);
  }
  // Midtklikk kommer som auxclick, ikke click
  function midtklikk(e) {
    if (e.button !== 1) return;
    const a = lenkeFra(e);
    if (!a) return;
    send('solgt_klikket', { til: a.getAttribute('href'), fra: tilbud && tilbud.contains(a) ? 'kort' : 'boks', nyFane: true });
    leggPaRabatt(() => false).catch(() => {});
  }
  boks.addEventListener('click', klikk);
  boks.addEventListener('auxclick', midtklikk);
  if (tilbud) {
    tilbud.addEventListener('click', klikk);
    tilbud.addEventListener('auxclick', midtklikk);
  }
})();
